import {
    IConfigSchema,
    TYPE_COLUMN_TOTAL,
    TYPE_COLUMN_HIGH_CHART
} from '@/containers/E4ImpactProjects/resources/config-schema';
import {entrepreneursThatHadScaledUpTheirBusinessTotalCalculation} from './total-calculations/entrepreneurs-that-had-scaled-up-their-business-total-calculation';
import {entrepreneursThatIncreasedNumberOfEmployeesTotalCalculation} from './total-calculations/entrepreneurs-that-increased-number-of-employees-total-calculation';
import {percentageOfFemaleEmployeesBeforeAndAfterChartCalculation} from './chart-calculations/percentage-of-female-employees-before-and-after-chart-calculation';
import {entrepreneursThatIncreasedTheTurnoverTotalCalculation} from './total-calculations/entrepreneurs-that-increased-the-turnover-total-calculation';
import {entrepreneursThatStartedImportTotalCalculation} from './total-calculations/entrepreneurs-that-started-import-total-calculation';
import {entrepreneursThatStartedExportTotalCalculation} from './total-calculations/entrepreneurs-that-started-export-total-calculation';
import {countriesImportingChartCalculation} from './chart-calculations/countries-importing-chart-calculation';
import {countriesExportingChartCalculation} from './chart-calculations/countries-exporting-chart-calculation';
import {entrepreneursThatOpenedNewBranchesTotalCalculation} from './total-calculations/entrepreneurs-that-opened-new-branches-total-calculation';
import {averageNumberOfNewBranchesTotalCalculation} from './total-calculations/average-number-of-new-branches-total-calculation';
import {entrepreneursWhoStartedNewBusinessTotalCalculation} from './total-calculations/entrepreneurs-who-started-new-business-total-calculation';
import {businessSectorChartCalculation} from './chart-calculations/business-sector-chart-calculation';

export const configSchema = (props: any): IConfigSchema => ([
    {
        rows: [
            {
                columns: [
                    {
                        title: '% entrepreneurs that had scaled up their business',
                        typeChart: TYPE_COLUMN_TOTAL,
                        transformData: entrepreneursThatHadScaledUpTheirBusinessTotalCalculation(props),
                    },
                    {
                        title: '% of entrepreneurs that increased the number of employees',
                        typeChart: TYPE_COLUMN_TOTAL,
                        transformData: entrepreneursThatIncreasedNumberOfEmployeesTotalCalculation(props),
                    },
                ]
            },
            {
                columns: [
                    {
                        title: 'KPI: Percentage of female employees before and after',
                        typeChart: TYPE_COLUMN_HIGH_CHART,
                        transformData: percentageOfFemaleEmployeesBeforeAndAfterChartCalculation(props),
                    },
                ]
            },
            {
                columns: [
                    {
                        title: '% Entrepreneurs that increased the turnover',
                        typeChart: TYPE_COLUMN_TOTAL,
                        transformData: entrepreneursThatIncreasedTheTurnoverTotalCalculation(props),
                    },
                ]
            },
            {
                columns: [
                    {
                        title: '% of entrepreneurs that started import',
                        typeChart: TYPE_COLUMN_TOTAL,
                        transformData: entrepreneursThatStartedImportTotalCalculation(props),
                    },
                    {
                        title: '% of entrepreneurs that started export',
                        typeChart: TYPE_COLUMN_TOTAL,
                        transformData: entrepreneursThatStartedExportTotalCalculation(props),
                    },
                ]
            },
            {
                columns: [
                    {
                        title: 'Countries Importing',
                        typeChart: TYPE_COLUMN_HIGH_CHART,
                        chartType: 'mapChart',
                        transformData: countriesImportingChartCalculation(props),
                    },
                    {
                        title: 'Countries Exporting',
                        typeChart: TYPE_COLUMN_HIGH_CHART,
                        chartType: 'mapChart',
                        transformData: countriesExportingChartCalculation(props),
                    },
                ]
            },
            {
                columns: [
                    {
                        title: '% of entrepreneurs that opened new branches',
                        typeChart: TYPE_COLUMN_TOTAL,
                        transformData: entrepreneursThatOpenedNewBranchesTotalCalculation(props),
                    },
                    {
                        title: '% entrepreneurs who started a new business',
                        typeChart: TYPE_COLUMN_TOTAL,
                        transformData: entrepreneursWhoStartedNewBusinessTotalCalculation(props),
                    },
                ]
            },
            {
                columns: [
                    {
                        title: 'Average number of new branches',
                        typeChart: TYPE_COLUMN_TOTAL,
                        transformData: averageNumberOfNewBranchesTotalCalculation(props),
                    },
                ]
            },
            {
                columns: [
                    {
                        title: 'Business Sector',
                        typeChart: TYPE_COLUMN_HIGH_CHART,
                        transformData: businessSectorChartCalculation(props),
                    },
                ]
            },
        ]
    },
]);